import { Asset, AssetsParams, DriverActivity, LiveApiAsset } from '@app/modules/location-client/location-api.models';
import { Location, VehicleListItem } from '@app/core/models/zonar-accounts.model';
import { User, UserProfile } from '@app/modules/auth/models/core-user-api.model';
import { mockIoInputs, mockIoLabels } from '@app/modules/asset-io/asset-io.mock';
import { mockMixedOpenEvents } from '@app/modules/events/events.mock';
import { ViewableAsset } from '@app/modules/location/models/viewable-asset.model';
import { VdoUser } from '@app/modules/auth/models/vdo-user';

export const mockAsset: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0851',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7lew',
  legacyAccount: 'tes1234',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 57,
  odometer: 89274,
  powerOn: true,
  heading: 149,
  idling: false,
  geoEventTs: new Date().toISOString(),
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '21000001'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: 'FOO-BAR'
  },
  make: 'Ford',
  assetName: 'ASSET_HD149',
  assetDisplayName: 'ASSET_HD149',
  driverProfileId: 'e600b066-ff9c-42f8-886b-8584637bcd6f',
  driverEventTs: '2016-08-29T09:12:33.001Z',
  driverChangeSource: 'mock name',
  openEvents: mockMixedOpenEvents,
  connectionIssue: false,
  driverActivity: DriverActivity.DRIVING
};

export const mockLiveApiAsset: LiveApiAsset = {
  id: '5N3ZA0NE6AN906847',
  accountId: 'asjkdf88-6c54-8du7-90e6-d701748f0852',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 57,
  odometer: 89274,
  powerOn: true,
  heading: 149,
  idling: false,
  deviceId: '21000001',
  vin: '5N3ZA0NE6AN906847',
  // assetName: 'ASSET_HD149',
  drivercardId: 'e600b066-ff9c-42f8-886b-8584637bcd6f'
};

export const mockAssetIdling: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0853',
  divisionId: '3ea02845-6c4e-48af-81e3-d488a11f7a50',
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7lex',
  legacyAccount: 'dbr47_rep1023',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 0,
  odometer: 89274,
  powerOn: true,
  heading: 148.7,
  idling: true,
  geoEventTs: new Date().toISOString(),
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '18000022'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: ''
  },
  make: 'Ford',
  assetName: 'ASSET_IDLING',
  assetDisplayName: 'ASSET_IDLING',
  connectionIssue: false
};

export const mockViewableIdling = {
  ...mockAssetIdling,
  distanceFromSelectedAsset: 0,
  iconUrl: null,
  className: null,
  subTitle: 'Idling',
  sidebarMessage: '0.0 mi. away',
  markerSubtitle: '0.0 mi. away'
};

export const mockAssetStopped: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0854',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7ley',
  legacyAccount: 'dbr47_rep1023',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 0,
  odometer: 89274,
  powerOn: false,
  heading: 148.7,
  idling: false,
  geoEventTs: new Date().toISOString(),
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '8000011'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: ''
  },
  assetName: 'ASSET_STOPPED',
  assetDisplayName: 'ASSET_STOPPED',
  make: 'Ford',
  connectionIssue: false
};

export const mockViewableStopped = {
  ...mockAssetStopped,
  distanceFromSelectedAsset: 0,
  iconUrl: null,
  className: null,
  subTitle: 'Powered Off',
  sidebarMessage: '0.0 mi. away',
  markerSubtitle: '0.0 mi. away'
};

export const mockAssetZtrak: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0855',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  assetId: '5N3ZA0NE6AN906847', //d290f1ee-6c54-i9s8-90e6-lkd98dhg7lez',
  legacyAccount: 'dbr47_rep1023',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 0,
  odometer: null,
  powerOn: null,
  heading: null,
  idling: null,
  geoEventTs: new Date().toISOString(),
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '3000000010'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: ''
  },
  assetName: 'ZTRAK_ASSET',
  assetDisplayName: 'ZTRAK_ASSET',
  make: 'Zonar',
  connectionIssue: false
};

export const mockViewableZtrak = {
  ...mockAssetZtrak,
  distanceFromSelectedAsset: 0,
  iconUrl: null,
  className: null,
  subTitle: 'zTrak',
  sidebarMessage: '0.0 mi. away',
  markerSubtitle: '0.0 mi. away'
};

export const mockAssetNoLocation: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0856',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7lfa',
  legacyAccount: 'dbr47_rep1023',
  latitude: null,
  longitude: null,
  speed: 0,
  odometer: 89274,
  powerOn: false,
  heading: 148.7,
  idling: false,
  geoEventTs: null,
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '8104900'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: ''
  },
  assetName: 'ASSET_STOPPED',
  assetDisplayName: 'ASSET_STOPPED',
  make: 'Ford',
  connectionIssue: false
};

export const mockViewableNoLocation = {
  ...mockAssetNoLocation,
  distanceFromSelectedAsset: 7607.862502749497,
  iconUrl: null,
  className: null,
  subTitle: 'MISSING GPS DATA',
  sidebarMessage: '7608 mi. away',
  markerSubtitle: '7608 mi. away'
};

export const mockAssetsParams: AssetsParams = {
  companyId: 'mockCompanyId',
  divisionId: 'mockDivisionId',
  assetIds: [],
  powerOn: true,
  // ztrak: false,
  idling: true,
  // minSpeed: 0,
  // maxSpeed: 100,
  sortBy: 'assetName',
  sortOrder: 'asc',
  pageSize: 150,
  vins: ['123']
};

export const mockLiveApiAssetsResponse = [mockLiveApiAsset];
export const mockAssetsResponse = [mockAssetIdling, mockAssetStopped, mockAssetZtrak, mockAssetNoLocation];
export const mockViewableAssetsResponse = [
  mockViewableIdling,
  mockViewableStopped,
  mockViewableZtrak,
  mockViewableNoLocation
];

export const mockNearbyAssetsResponse = [mockViewableIdling, mockViewableStopped, mockViewableZtrak];

export const mockVehiclesMap = new Map<string, VehicleListItem>();
for (let asset of [...mockAssetsResponse, ...mockViewableAssetsResponse, mockAsset]) {
  // asset.assetId =  asset.assetTypeInfo?.vin
  const v: VehicleListItem = {
    id: 0,
    displayName: asset.assetName,
    vrn: asset.assetName,
    vin: asset.assetId,
    lastDataRecordedOn: '',
    status: '',
    state: '',
    siteId: asset.divisionId
  };
  asset.vin = v.vin;
  asset.vrn = v.vrn;
  asset.assetTypeInfo = {
    vin: v.vin,
    licenseNumber: v.vrn
  };
  mockVehiclesMap.set(asset.assetId, v);
}

export const mockLocationApiResponse = { assets: mockAssetsResponse, nextpageToken: '' };

export const mockAddress = {
  street: 'mockStreet',
  city: 'mockCity',
  state: 'mockState',
  zip: 'mockZip',
  country: 'mockCountry',
  county: 'mockCounty'
};

export const mockPosition = {
  lat: 123,
  lon: 456
};

export const mockLocation: Location = {
  id: mockAsset.divisionId,
  name: 'mockName',
  address: mockAddress,
  timezone: 'mockTimezone',
  position: mockPosition
};

export const mockUser: VdoUser = {
  id: 123,
  firstName: 'Mock',
  lastName: 'User',
  identityProviderId: 'mockIdentityProviderId',
  email: 'foo@bar.com',
  account_id: 456,
  account_name: 'testAccount',
  permissions: [],
  sp_id: '123',
  userName: 'userName',
  accountID: 456,
  accountName: 'testAccount',
  sub: '',
  userID: 123,
  userEmail: 'foo@bar.com',
  spId: 123
};

// export const mockLocation: Location = {
//   id: mockAsset.homeLocationId,
//   name: 'mockName',
//   address: mockAddress,
//   timezone: 'mockTimezone',
//   position: mockPosition
// };

export const mockUserProfile: UserProfile = {
  id: 'mockUserProfile',
  companyEmail: 'mock@email.tld',
  status: 'ACTIVE',
  userId: 'mockUser',
  employeeNumber: 'mockEmployeeNumber',
  homeLocationId: 'mockHomeLocation',
  applicationId: '0961d523-ef76-489a-8613-e0e639d5b233',
  companyId: 'mockCompanyId',
  divisions: ['mockDivision'],
  roles: ['mockRole']
};
export const mockUserProfileAllDivs: UserProfile = {
  id: 'mockUserProfileAllDivs',
  companyEmail: 'mock@email.tld',
  status: 'ACTIVE',
  userId: 'mockUser',
  employeeNumber: 'mockEmployeeNumber',
  homeLocationId: 'mockHomeLocation',
  applicationId: '0961d523-ef76-489a-8613-e0e639d5b233',
  companyId: 'mockCompanyId',
  divisions: [],
  roles: ['mockRole']
};
export const mockZonarUserProfile: UserProfile = {
  id: 'mockZonarUserProfile',
  companyEmail: 'mock@email.tld',
  status: 'ACTIVE',
  userId: 'mockUser',
  employeeNumber: 'mockEmployeeNumber',
  homeLocationId: 'mockHomeLocation',
  applicationId: '0961d523-ef76-489a-8613-e0e639d5b233',
  companyId: null,
  divisions: [],
  roles: ['mockRole']
};

export const mockUserProfile1: UserProfile = {
  id: 'mockUserProfile1',
  companyEmail: 'mock1@email.tld',
  status: 'ACTIVE',
  userId: 'mockUser1',
  employeeNumber: 'mockEmployeeNumber1',
  homeLocationId: 'mockHomeLocation',
  applicationId: '0961d523-ef76-489a-8613-e0e639d5b233',
  companyId: 'mockCompanyId',
  divisions: ['mockDivision'],
  roles: ['mockRole']
};

export const mockUserProfile2: UserProfile = {
  id: 'mockUserProfile12',
  companyEmail: 'mock2@email.tld',
  status: 'ACTIVE',
  userId: 'mockUser2',
  employeeNumber: 'mockEmployeeNumber2',
  homeLocationId: 'mockHomeLocation',
  applicationId: '0961d523-ef76-489a-8613-e0e639d5b233',
  companyId: 'mockCompanyId',
  divisions: ['mockDivision'],
  roles: ['mockRole']
};

export const mockAssetWithDriverProfileId: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0851',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  driverProfileId: '0066c8f7-b9f3-451c-bff7-0ba103e9296a',
  driverFirstName: 'Dev',
  driverLastName: 'Test',
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7lew',
  legacyAccount: 'tes1234',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 57,
  odometer: 89274,
  powerOn: true,
  heading: 149,
  idling: false,
  geoEventTs: '2016-08-29T09:12:33.001Z',
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '21000001'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: 'FOO-BAR'
  },
  assetName: 'ASSET_HD149'
};
export const mockAssetWithoutDriverFirstName: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0851',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  driverProfileId: '0066c8f7-b9f3-451c-bff7-0ba103e9296a',
  driverFirstName: null,
  driverLastName: 'Test',
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7lew',
  legacyAccount: 'tes1234',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 57,
  odometer: 89274,
  powerOn: true,
  heading: 149,
  idling: false,
  geoEventTs: '2016-08-29T09:12:33.001Z',
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '21000001'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: 'FOO-BAR'
  },
  assetName: 'ASSET_HD149'
};
export const mockAssetWithoutDriverLastName: Asset = {
  companyId: 'asjkdf88-6c54-8du7-90e6-d701748f0851',
  divisionId: 'sk8765fdk-ld0s-4b01-9kdu-d701748f0851',
  driverProfileId: '0066c8f7-b9f3-451c-bff7-0ba103e9296a',
  driverFirstName: 'Dev',
  driverLastName: null,
  assetId: 'd290f1ee-6c54-i9s8-90e6-lkd98dhg7lew',
  legacyAccount: 'tes1234',
  latitude: 47.6395,
  longitude: -120.6825,
  speed: 57,
  odometer: 89274,
  powerOn: true,
  heading: 149,
  idling: false,
  geoEventTs: '2016-08-29T09:12:33.001Z',
  inputs: { ...mockIoInputs },
  labels: { ...mockIoLabels },
  ecmConnected: true,
  //homeLocationId: '9f5d0228-f33e-4b8c-8aa4-b8c986a39860',
  legacyAttributes: {
    gpssn: '21000001'
  },
  assetTypeInfo: {
    vin: '5N3ZA0NE6AN906847',
    licenseNumber: 'FOO-BAR'
  },
  assetName: 'ASSET_HD149'
};
export const mockAssetList: Array<ViewableAsset> = [
  {
    assetId: '073cd9dc-a6c7-4361-ade7-bad4451259bc',
    companyId: 'c25d98d4-e7c8-4510-84bc-54f43af2f006',
    divisionId: '3afa93af-ffc1-4e0d-8977-83f318508d5c',
    legacyAccount: 'TRANSPORT VUILLAUME',
    latitude: 49.2110534,
    longitude: 5.9489608,
    idling: false,
    ecmConnected: false,
    speed: 0,
    powerOn: false,
    heading: 35600,
    //homeLocationId: '1',
    assetName: 'DE-731-FB',
    driverProfileId: '123421ca-7528-4d79-9098-1989cd507c60',
    driverFirstName: 'MICKAEL DANIEL',
    driverLastName: 'VUILLAUME',
    driverChangeSource: 'EXTERNAL',
    driverEventTs: '2024-03-26T09:44:14.345+00:00',
    geoEventTs: '2024-03-27T03:42:23.000+00:00',
    legacyAttributes: {
      subtype: null,
      gpssn: '867648048070237',
      type: null
    },
    connectionIssue: false
  },
  {
    assetId: '08c555f2-05e8-4ac0-8c0b-f71b0f3db30f',
    companyId: 'c25d98d4-e7c8-4510-84bc-54f43af2f006',
    divisionId: '3afa93af-ffc1-4e0d-8977-83f318508d5c',
    legacyAccount: 'TRANSPORT VUILLAUME',
    latitude: 48.355044,
    longitude: 8.0176028,
    idling: true,
    ecmConnected: false,
    speed: 0,
    powerOn: true,
    heading: 18400,
    //homeLocationId: 'edafdc1f-036b-4146-adb8-6cde4e787475',
    assetName: 'EL-327-NF',
    driverProfileId: 'e7e37baa-5278-4136-9d5e-6280f2c8c1d6',
    driverFirstName: 'FREDERIC SERGE',
    driverLastName: 'MONCHOT',
    driverChangeSource: 'EXTERNAL',
    driverEventTs: '2024-04-11T03:02:41.135+00:00',
    geoEventTs: '2024-04-11T07:39:13.000+00:00',
    legacyAttributes: {
      subtype: null,
      gpssn: '867648048047748',
      type: null
    },
    connectionIssue: true
  },
  {
    assetId: '20ed2192-3730-4a98-926f-b66a5ee9a559',
    companyId: 'c25d98d4-e7c8-4510-84bc-54f43af2f006',
    divisionId: '3afa93af-ffc1-4e0d-8977-83f318508d5c',
    legacyAccount: 'TRANSPORT VUILLAUME',
    latitude: 49.6222931,
    longitude: 6.1445658,
    idling: true,
    ecmConnected: false,
    speed: 0,
    powerOn: true,
    heading: 19700,
    //homeLocationId: 'edafdc1f-036b-4146-adb8-6cde4e787475',
    assetName: 'DT-933-HQ',
    driverProfileId: '7f39e77d-32fb-4473-9a26-d591bc457a04',
    driverFirstName: 'JORDAN',
    driverLastName: '',
    driverChangeSource: 'EXTERNAL',
    driverEventTs: '2024-04-08T03:39:32.424+00:00',
    geoEventTs: '2024-04-11T07:20:20.000+00:00',
    legacyAttributes: {
      subtype: null,
      gpssn: '867648048079410',
      type: null
    },
    connectionIssue: true
  },
  {
    assetId: '29df6029-ad84-4d0d-aa83-7835b2202013',
    companyId: 'c25d98d4-e7c8-4510-84bc-54f43af2f006',
    divisionId: '3afa93af-ffc1-4e0d-8977-83f318508d5c',
    legacyAccount: 'TRANSPORT VUILLAUME',
    latitude: 49.0982644,
    longitude: 6.1905303,
    idling: true,
    ecmConnected: false,
    speed: 0,
    powerOn: true,
    heading: 12600,
    //homeLocationId: 'edafdc1f-036b-4146-adb8-6cde4e787475',
    assetName: 'GJ-241-TA',
    driverProfileId: '1',
    driverFirstName: 'LOIC YVES',
    driverLastName: 'DURAND',
    driverChangeSource: 'EXTERNAL',
    driverEventTs: '2024-04-11T05:08:48.478+00:00',
    geoEventTs: '2024-04-11T07:39:34.000+00:00',
    legacyAttributes: {
      subtype: null,
      gpssn: '867648048048803',
      type: null
    },
    connectionIssue: true
  }
];

export const daysWithActivitiesMock = ['2024-04-11', '2024-04-10', '2024-04-09'];
